import * as React from 'react';
import openInClientStore from '../../utils/openInClientStore';
import strings from 'owa-strings/owa-extensibility-strings';
import { isInClientStoreEnabled } from 'owa-addins-feature-flags';
import { observer } from 'mobx-react';

let styles = require('./MinorFrame.scss');

export interface MinorFrameProps {
    onClickUninstall: () => void;
}

@observer
export default class MinorFrame extends React.Component<MinorFrameProps, any> {
    constructor(props: MinorFrameProps, context?: any) {
        super(props, context);
        this.handleRemoveLinkClick = this.handleRemoveLinkClick.bind(this);
    }

    handleRemoveLinkClick = (event: React.MouseEvent<EventTarget>) => {
        event.stopPropagation();
        event.preventDefault();

        if (this.props.onClickUninstall) {
            this.props.onClickUninstall();
        }

        if (isInClientStoreEnabled()) {
            openInClientStore();
        }
    };

    render(): JSX.Element {
        return (
            <div className={styles.divContainer}>
                <div>
                    {strings.gdprMinorWarningText}{' '}
                    <a href="" onClick={this.handleRemoveLinkClick}>
                        {strings.gdprMinorRemoveAddinText}
                    </a>
                </div>
            </div>
        );
    }
}
